import { audioBufferToMP3 } from "@/utils/functions/audioBufferToMP3";
import { useEffect, useRef, useState } from "react";

const useRecorder = () => {
  const timeInterval = useRef<NodeJS.Timeout | undefined>(undefined);
  const stream = useRef<MediaStream | null>(null);
  const mediaRecorder = useRef<MediaRecorder | null>(null);

  const [recording, setRecording] = useState(false);
  const [recodingTime, setRecodingTime] = useState(0);
  const [mp3Converting, setMp3Converting] = useState(false);
  const [audioBlob, setAudioBlob] = useState<Blob | null>(null);

  const startRecording = async () => {
    try {
      if (navigator) {
        stream.current = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        mediaRecorder.current = new MediaRecorder(stream.current);
        mediaRecorder.current.start();
        setRecording(true);
        timeInterval.current = setInterval(
          () => setRecodingTime((prev) => prev + 1),
          1000,
        );
      }
    } catch (e) {
      // console.log(e);
    }
  };

  const stopRecording = () => {
    mediaRecorder.current?.stop();
  };

  useEffect(() => {
    const handleStopMediaRecorder = () => {
      setRecording(false);
      clearInterval(timeInterval.current);
      timeInterval.current = undefined;
      setRecodingTime(0);
      stream.current?.getTracks().forEach((track) => {
        track.stop();
      });
    };

    const handleDataAvailable = (e: BlobEvent) => {
      setMp3Converting(true);
      e.data.arrayBuffer().then((arrBuffer) => {
        const audioCtx = new window.AudioContext();
        audioCtx.decodeAudioData(arrBuffer).then((buffer) => {
          setAudioBlob(audioBufferToMP3(buffer));
          setMp3Converting(false);
        });
      });
    };

    if (mediaRecorder.current) {
      mediaRecorder?.current?.addEventListener(
        "dataavailable",
        handleDataAvailable,
      );
      mediaRecorder?.current?.addEventListener("stop", handleStopMediaRecorder);
    }

    return () => {
      if (recording) clearInterval(timeInterval.current);
      mediaRecorder?.current?.removeEventListener(
        "dataavailable",
        handleDataAvailable,
      );
      mediaRecorder?.current?.removeEventListener(
        "stop",
        handleStopMediaRecorder,
      );
    };
  }, [recording]);

  return {
    audioBlob,
    setAudioBlob,
    startRecording,
    stopRecording,
    recodingTime,
    recording,
    mp3Converting,
  };
};

export default useRecorder;
